import { LockIcon } from '@mote/assets/icons'
import { Emoji } from '../../shared/components'

/**
 * @typedef {Object} VisibilityStateIconProps
 * @property {'private' | 'organization' | 'public'} visibility
 */

/**
 * @param props {VisibilityStateIconProps}
 * @returns {JSX.Element}
 */
export function VisibilityStateIcon(props) {
  switch (props.visibility) {
    case 'private':
      return <LockIcon />
    case 'organization':
      return (
        <Emoji noTooltip fontSize='inherit'>
          🏫
        </Emoji>
      )
    case 'public':
    default:
      return <></>
  }
}
